export default __webpack_public_path__ + "static/media/SmartCity.bf15b710.jpg";